module.exports = __webpack_public_path__ + "img/project-federated.25ccf3ee.svg";